import { UserProfileModel } from '@/apiTypes/UserTypes';

type UserWithHeapIds = { uid: string; id: string; sub?: string };

/**
 * User properties for `heap.addUserProperties` after `heap.identify(uid)`.
 * With a full profile, includes auth0 `sub` and Britebound `uid`; without profile, only `user_id` is set.
 */
export function buildHeapIdentifyUserProperties(
    user: UserWithHeapIds,
    userProfile: UserProfileModel | undefined,
    configs: { [key: string]: string },
): Record<string, string> {
    const base: Record<string, string> = {
        user_id: user.id,
    };
    if (!userProfile) {
        return base;
    }
    const withProfile: Record<string, string> = {
        ...base,
        auth_provider: configs['authProvider'] ?? 'microsoft_entra_id',
        email: userProfile.email || '',
    };
    if (user.sub) {
        withProfile.sub = user.sub;
    }
    withProfile.uid = user.uid;
    return withProfile;
}

/**
 * Britebound `uid` and app user `id` are required to call `identify` / `addUserProperties`.
 * (`window.heap` may be missing until the script stub loads — check separately.)
 */
export function hasHeapUserIds(
    user: { uid?: string; id?: string; sub?: string } | null | undefined,
): user is UserWithHeapIds {
    return Boolean(user?.uid && user?.id);
}
